import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { resetEg, saveEquipmentGroup, validateEg } from "../../../actions/eg-kanban";
import { updateChatEGList } from '../../../actions/chat';
import { isToday, usePermission, isUUID } from "../../../helpers/common";
import { EG_OPTION_TYPES, EQUIPMENT_HANDLING, EQUIPMENT_REMOTECONTROL, EQUIPMENT_SCALE } from "../../../constants";

const ActionButton = props => {
    const { farmId, isRequestingSave, haveChanges, search, kanban, actions } = props;

    const history = useHistory();
    const back = () => history.push(`/home/farm/${farmId}/map/eg?sub=1`);
    const onSave = () => {
        const success = () => actions.updateChatEGList(farmId);

        for (const id in kanban) {
            if (EG_OPTION_TYPES.indexOf(id) >= 0) continue;                       //handle only EG column
            const item = kanban[id];
            let validateEg = false;
            if (item.modeTypeId === 1) {
                let implementId = item && item.list.length > 0 ? item.list[1] : null;
                let filteredImplement = props.optionList && props.optionList.implement && props.optionList.implement.list && props.optionList.implement.list.length > 0 ?
                    props.optionList.implement.list.filter(e => e.equipment_uuid === implementId) : [];
                   
                const isEGHandling = filteredImplement.length > 0 ? filteredImplement[0].equipment_type_id === EQUIPMENT_HANDLING : false;
                const isEGScale = filteredImplement.length > 0 ? filteredImplement[0].equipment_type_id === EQUIPMENT_SCALE : false;
                const isEGRemoteControl = filteredImplement.length > 0 ? filteredImplement[0].equipment_type_id === EQUIPMENT_REMOTECONTROL : false;

                validateEg = !((isEGHandling ||isEGRemoteControl ) ? true : isUUID(item.list[0]));    //to check vehicle is assigned or not
                if (isEGScale) {
                    validateEg = false;
                }
            }
            else validateEg = !isUUID(item.list[3]);                        //to check whether operator and device is assigned or not
            if (validateEg) return actions.validateEg(true);
        }
        actions.saveEquipmentGroup(success)
    };
    const onReset = () => actions.resetEg();
    const allow = usePermission();
    const isAllowAdd = allow("equipment-group", "create") ? isToday(search.range) : false;
    const isAllowEdit = allow("equipment-group", "edit") ? isToday(search.range) : false;

    return <>
        <Button variant="danger" size="sm" className="float-right" title="Cancel"
            disabled={isRequestingSave} onClick={back}>
            <i className="fa fa-times-circle mr-1"></i> Cancel
        </Button>
        {(isAllowAdd || isAllowEdit) && <Button variant="primary" size="sm" className="mr-3 float-right" title="Save"
            disabled={isRequestingSave || !haveChanges} onClick={onSave}>
            <i className="fa fa-floppy-o mr-1"></i> {isRequestingSave ? "Saving..." : "Save"}
        </Button>}
        {(haveChanges && !isRequestingSave) && (isAllowAdd || isAllowEdit) &&
            <Button variant="outline-primary" size="sm" className="mr-3 float-right"
                title="Reset" onClick={onReset}>
                <i className="fa fa-refresh mr-1" />Reset
            </Button>}
    </>;
};

const mapStateToProps = state => ({
    isRequestingSave: state.egKanban.isRequestingSave,
    farmId: state.egKanban.filters.farmId,
    haveChanges: Object.keys(state.egKanban.kanban).length > 0 ?
        Object.keys(state.egKanban.kanban)
            .filter(e => EG_OPTION_TYPES.indexOf(e) < 0)
            .map(id => state.egKanban.kanban[id])
            .filter(e => e && e.isChanged).length > 0 : false,
    kanban: state.egKanban.kanban,
    search: { range: state.analyze.searchParams.range },
    optionList: state.egKanban.optionList
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ resetEg, saveEquipmentGroup, updateChatEGList, validateEg }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionButton);